import { format, eachDayOfInterval, isMonday, isTuesday, isWednesday, isThursday, isFriday, isSaturday, isSunday } from "date-fns";

type RecurrencePattern = "weekdays" | "monday" | "tuesday" | "wednesday" | "thursday" | "friday" | "saturday" | "sunday";

/**
 * Generates dates based on recurrence pattern within a date range
 */
export function generateSessionDates(
  startDate: Date,
  endDate: Date,
  pattern: RecurrencePattern
): Date[] {
  // Get all days in the range
  const allDates = eachDayOfInterval({ start: startDate, end: endDate });
  
  // Filter dates based on pattern
  return allDates.filter(date => {
    if (pattern === "weekdays") {
      // Monday to Friday (1-5)
      const day = date.getDay();
      return day >= 1 && day <= 5;
    }
    
    // Specific day patterns
    if (pattern === "monday") return isMonday(date);
    if (pattern === "tuesday") return isTuesday(date);
    if (pattern === "wednesday") return isWednesday(date);
    if (pattern === "thursday") return isThursday(date);
    if (pattern === "friday") return isFriday(date);
    if (pattern === "saturday") return isSaturday(date);
    if (pattern === "sunday") return isSunday(date);
    
    return false;
  });
}

/**
 * Format the recurrence pattern for display
 */
export function formatRecurrencePattern(pattern: RecurrencePattern): string {
  switch (pattern) {
    case "weekdays":
      return "All weekdays (Mon-Fri)";
    case "monday":
      return "Every Monday";
    case "tuesday":
      return "Every Tuesday";
    case "wednesday":
      return "Every Wednesday";
    case "thursday":
      return "Every Thursday";
    case "friday":
      return "Every Friday";
    case "saturday":
      return "Every Saturday";
    case "sunday":
      return "Every Sunday";
    default:
      return "Custom";
  }
}
